<template>
  <div class="ioRecord">
    <div class="right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label>停车道路:</label>
            <el-select
              filterable
              v-model="search.parkingId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in parkingList"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>车牌:</label>
            <input
              v-model="search.carNumber"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label>积分时间:</label>
            <bosk-shortcut-date
              v-on:current-date-change="onCurrentDateChange"
            ></bosk-shortcut-date>
          </div>
          <div class="form-group">
            <label>积分操作类型:</label>
            <el-select
              filterable
              v-model="search.eventAction"
              placeholder="请选择"
            >
              <el-option
                v-for="item in eventActionType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :loading="loading"
                size="small"
              >
                查询
              </el-button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <div v-show="showList" class="list-right">
          <el-table
            v-loading="loading"
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column show-overflow-tooltip label="停车场名称">
              <template slot-scope="scope">
                {{
                  scope.row.parkingId
                    ? JSON.parse(scope.row.parkingId).parkingName
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="车牌号码">
              <template slot-scope="scope">
                {{
                  scope.row.carNumber
                    ? JSON.parse(scope.row.carNumber).carNumber
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="事件名称"
              prop="eventType"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="积分操作类型"
              prop="eventActionName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="积分变更时间"
              prop="eventTime"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="积分值"
              prop="integralVal"
            ></el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="积分兑换金额(元)"
              prop="integralExchangeMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="关联支付总账单号"
              prop="orderNumPay"
            ></el-table-column>
            <!-- <el-table-column
              show-overflow-tooltip
              label="需再支付金额(元)"
              prop="payMoneyTotal"
            ></el-table-column> -->
            <el-table-column
              show-overflow-tooltip
              label="备注"
              prop="attr1"
            ></el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <Page
      v-show="showList"
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    >
    </Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { EVENT_ACTION } from "./constant";
import { queryPointsUsedRecord, fetchParkigList } from "@/api/url";
import AreaTree from "@/page/commons/areaTree";
import Page from "@/page/commons/page";

export default {
  data() {
    return {
      loading: false,
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      tableListData: [],
      tableListDataTitle: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        parkingId: "",
        carNumber: "",
        eventTime: [],
        eventAction: "",
      },
      value4: "",
      pageObj: {},
      parkingList: [],
      eventActionType: EVENT_ACTION,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      this.$get(queryPointsUsedRecord(), {
        page: curPage,
        limit: this.search.pageSize,
        parkingId: this.search.parkingId,
        carNumber: this.search.carNumber,
        eventTime:
          this.search.eventTime.length > 0
            ? JSON.stringify(this.search.eventTime)
            : null,
        eventAction: this.search.eventAction,
      })
        .then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.pageObj = { ...pageObj };
          // _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
          _this.totalMap = data.data.totalMap;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },

    getParkingList() {
      return this.$get(fetchParkigList()).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.parkingList = data;
        }
      });
    },

    onCurrentDateChange(v) {
      this.search.eventTime = v ? [...v] : [];
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
        }
        if (index === 6) {
          sums[index] = this.totalMap?.integralExchangeMoneyTotal ?? 0;
        }
      });
      return sums;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  components: {
    Page,
    AreaTree,
  },

  mounted: function() {
    this.getParkingList();
    this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
  width: 16px;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
}
.show-list {
  height: 500px;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.download_btn {
  display: inline-block;
  margin-left: 15px;
}
</style>
